import React, { useState, useRef, useEffect } from "react";
import { Button } from "antd";
import { Http } from "../../../helpers/axois";
import "./styles/upload-widget.scss";
import { Spinner } from "../../../helpers/commonUi/Spinner";
import { useToast } from '../../../helpers/commonFunction';
import { logger } from "../../../constant/winston";

interface IProps {
  setObjectUrl: (key: string, value: any) => void;
  orgId: string;
  widget:any;
  editable:boolean;
}

const UploadWidget: React.FC<IProps> = ({ setObjectUrl, orgId, widget, editable }) => {
  const inputRef: any = useRef(null);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const { objectUrl } = widget
  const fileName = objectUrl.substring(objectUrl.lastIndexOf('/')+1);
  const { SuccessToast, ErrorToast } = useToast();

  const handleInputTrigger = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleInputChange = async (e: any) => {
    if (e.target.files.length) {
      setLoading(true);
      const file = e.target.files[0];
      setFile(file.name)
      const endpoint = `/orgs/${orgId}/store/artifacts/upload`;

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res: any = await Http.post(endpoint, formData).toPromise();
        setObjectUrl('objectUrl', res.objectUrl);
        setLoading(false);
        SuccessToast("widget uploaded");
      } catch (e) {
        logger.error(e)
        ErrorToast("Failed to upload widget");
        setLoading(false);
      } finally {
        if (inputRef && inputRef.current) {
          inputRef.current.value = ""
        }
      }
    }
  };

  useEffect(() => {
    setFile(fileName)
  }, [fileName])

  return (
    <div className="upload-widget">
      <h5>
        <span>*</span>{" "}
        Upload Application
      </h5>
      <div className="upload-widget-content">
        <input
          type="file"
          style={{ display: "none" }}
          ref={inputRef}
          onChange={handleInputChange}
          accept=".zip"
          disabled={editable}
        />
        {!file ?
          <Button data-test-id="upload_applicaction" onClick={handleInputTrigger} loading={loading}>
            Upload Application
          </Button>
          : <div className="widget-file">
            <p>
              {loading ? <Spinner /> : `File Name: ${file}`}
            </p>
          <button
            data-test-id="close"
            className={`${!editable ? "widget-cancel-button" : "widget-cancel-disabled"}`}
            onClick={() => {
              setFile(null);
              setObjectUrl('objectUrl', "");
            }}
            disabled={editable}
          >
            X
          </button>
          </div>}
      </div>
    </div>
  );
};

export default UploadWidget;
